module.exports = require("@modelcontextprotocol/sdk/server/index.js");